export function initSmoothScroll(container) {
  //
  // LENIS SCROLL
  //
  const lenis = new Lenis({
    duration: 1,
    smoothWheel: true,
    lerp: 0.07,
  });
  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  //function raf(time) {
  //lenis.raf(time);
  //requestAnimationFrame(raf);
  //}
  //requestAnimationFrame(raf);

  document.querySelectorAll('a.goto[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      lenis.scrollTo(this.getAttribute("href"));
      $(".btn-hamburger").removeClass("active");
      $("main").removeClass("nav-active");
      $(".no-scroll-overlay").removeClass("active");
      $(".btn-click").removeClass("active");
    });
  });

  document.querySelectorAll('.goto a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      lenis.scrollTo(this.getAttribute("href"));
      $(".btn-hamburger").removeClass("active");
      $("main").removeClass("nav-active");
      $(".no-scroll-overlay").removeClass("active");
      $(".btn-click").removeClass("active");
    });
  });


}
